import React from 'react';
import FormSwitchContain from '../../../Componant/Forms/FormWidget/FormSwitch';

const Switch = () => {
  return (
    <div className='page-body'>
      <FormSwitchContain />
    </div>
  );
};

export default Switch;
